.root {
  --mantine-font-size-xs: calc(0.75rem * var(--mantine-scale) * 1.1);
  --mantine-font-size-sm: calc(0.875rem * var(--mantine-scale) * 1.1);
  --mantine-font-size-md: calc(1rem * var(--mantine-scale) * 1.1);
  --mantine-font-size-lg: calc(1.125rem * var(--mantine-scale) * 1.1);
  --mantine-font-size-xl: calc(1.25rem * var(--mantine-scale) * 1.1);
}